export default __webpack_public_path__ + "static/media/Summoner's Cincture of Prestige.dc733f72.jpg";